import type { CategoriesApi } from "@/v2/api/metadata/categories";
import { buildFeedConfigTab } from "@/v2/kits/feed-config";
import { createCategoryFeedConfigApi } from "./category-feed-config-api";

/** Saves are inline (toggle / drawer); dialog footer Save is a no-op on this tab. */
export function createFeedConfigTab(categories: CategoriesApi) {
  return buildFeedConfigTab(createCategoryFeedConfigApi(categories));
}
